<!-- NAVBAR -->
<ng-container *ngTemplateOutlet="navbar"></ng-container>
<!--/ NAVBAR -->

<!-- MENU -->
<ng-container *ngTemplateOutlet="menu"></ng-container>
<!--/ MENU -->

<!-- APP-CONTENT -->
<div class="app-content content">
  <div class="content-overlay"></div>
  @if (!coreConfig.layout.navbar.hidden) {
    <div class="header-navbar-shadow"></div>
  }
  <!-- CONTENT -->
  <content></content>
  <!--/ CONTENT -->
</div>
<!--/ APP-CONTENT -->

<!-- FOOTER -->
<ng-container *ngTemplateOutlet="footer"></ng-container>
<!--/ FOOTER -->

<!-- PARTIALS ---------------------------------------------------------------------------------------- -->

<!-- NAVBAR -->
<ng-template #navbar>
  @if (!coreConfig.layout.navbar.hidden) {
    <app-navbar
      [ngClass]="[
        coreConfig.layout.navbar.customBackgroundColor === true
          ? coreConfig.layout.navbar.background +
            ' ' +
            coreConfig.layout.navbar.type +
            ' ' +
            coreConfig.layout.navbar.backgroundColor
          : coreConfig.layout.navbar.background + ' ' + coreConfig.layout.navbar.type,
        coreConfig.layout.navbar.type === 'floating-nav' ? 'container-xxl' : '',
      ]"
      class="header-navbar navbar navbar-expand-lg align-items-center navbar-shadow">
    </app-navbar>
  }
</ng-template>
<!--/ NAVBAR -->

<!-- MENU -->
<ng-template #menu>
  @if (!coreConfig.layout.menu.hidden) {
    <core-sidebar
      name="menu"
      [collapsed]="coreConfig.layout.menu.collapsed"
      collapsibleSidebar="min-width: 1200px"
      class="main-menu menu-fixed menu-accordio menu-shadow"
      overlayClass="sidenav-overlay"
      [ngClass]="[
        coreConfig.layout.skin === 'semi-dark' || coreConfig.layout.skin === 'dark' ? 'menu-dark' : 'menu-light',
        coreConfig.layout.menu.collapsed ? '' : 'expanded',
      ]">
      <app-menu
        menuType="vertical-menu"
        class="vertical-menu"></app-menu>
    </core-sidebar>
  }
</ng-template>
<!--/ MENU -->

<!-- FOOTER -->
<ng-template #footer>
  @if (!coreConfig.layout.footer.hidden) {
    <footer
      class="footer position-relative bottom-0 end-0"
      [ngClass]="
        coreConfig.layout.footer.customBackgroundColor === true
          ? coreConfig.layout.footer.background +
            ' ' +
            coreConfig.layout.footer.type +
            ' ' +
            coreConfig.layout.footer.backgroundColor
          : coreConfig.layout.footer.background + ' ' + coreConfig.layout.footer.type
      "></footer>
  }
</ng-template>
<!-- / FOOTER -->
